import React, { Children, useState } from 'react';
import classnames from 'classnames';

import { Header } from 'formlabs-web-components/Type';
import { Cell, Grid } from 'formlabs-web-components/Grid';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';
import Picture from 'formlabs-web-components/Media/Picture';
import useIsMobile from '../../hooks/useIsMobile';

import TextPlugin from '../cms/TextPlugin';

import './TabbedSection.module.css';

const TabbedSection = ({ children, metaContent, title }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = Children.map(children, child => child.props);
  const isMedium = useIsMobile(940);
  if (!tabs.length) {
    return null;
  }

  return (
    <Grid direction="x">
      {!isMedium && (
        <Cell largeSize={8} mediumSize={24} styleName={'left'}>
          <div styleName="header">
            <Header level={1} displayAs={6}>
              {title}
            </Header>
          </div>
          <ul styleName="tabs" role="menu">
            {tabs.map((tab, index) => {
              const { name, image, shortDescription } = tab;
              return (
                <li key={name}>
                  <InteractiveDiv
                    role="menuitem"
                    handler={() => setActiveTab(index)}
                    styleName={classnames('tab', {
                      active: activeTab === index
                    })}
                  >
                    <div styleName="tab-title">
                      <Header level={2} displayAs={6}>
                        {name}
                      </Header>
                      <p>{shortDescription}</p>
                    </div>
                    <div styleName="tab-image">
                      <Picture largeImage={image} />
                    </div>
                    <i className="fl-arrow-right" styleName="arrow" />
                  </InteractiveDiv>
                </li>
              );
            })}
          </ul>
          {metaContent ? <TextPlugin body={metaContent} /> : null}
        </Cell>
      )}
      {!isMedium && (
        <Cell largeSize={16} mediumSize={24}>
          {children[activeTab]}
        </Cell>
      )}
      {isMedium &&
        children.map(child => {
          return (
            <Cell largeSize={16} mediumSize={24}>
              {child}
            </Cell>
          );
        })}
    </Grid>
  );
};

export default TabbedSection;
